module.exports = __webpack_public_path__ + "static/img/透明版装饰.b42c745d.png";